import React, { useState } from "react";
import "./FAQ.css";
import { useTranslation } from "react-i18next";

const faqData = [
  { q: "faq_q1", a: "faq_a1" },
  { q: "faq_q2", a: "faq_a2" },
  { q: "faq_q3", a: "faq_a3" },
  { q: "faq_q4", a: "faq_a4" },
  { q: "faq_q5", a: "faq_a5" },
  { q: "faq_q6", a: "faq_a6" },
  { q: "faq_q7", a: "faq_a7" },
  { q: "faq_q8", a: "faq_a8" },
  
  { q: "faq_q10", a: "faq_a10" },
  { q: "faq_q11", a: "faq_a11" },
  { q: "faq_q12", a: "faq_a12" },
  { q: "faq_q13", a: "faq_a13" },
  { q: "faq_q14", a: "faq_a14" },
  { q: "faq_q15", a: "faq_a15" }
];

const FAQ = () => {

  const { t } = useTranslation();

  const [activeIndex, setActiveIndex] = useState(null);
  const [search, setSearch] = useState("");

  const filteredFAQ = faqData.filter((faq) =>
    t(faq.q).toLowerCase().includes(search.toLowerCase())
  );

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
return (
<section className="faq-section">

{/* HEADER */}

<div className="faq_header">

<h1>{t("faq_title")}</h1>



</div>


<div className="faq-dot dot1"></div>
<div className="faq-dot dot2"></div>
<div className="faq-dot dot3"></div>

<div className="shape-left-2"></div>
<div className="shape-right-2"></div>

<div className="faq-dot dot4"></div>
<div className="faq-dot dot5"></div>


<div className="faq-container">

{/* SEARCH */}

<div className="faq-search">
<input
type="text"
placeholder={t("faq_search")}
value={search}
onChange={(e) => setSearch(e.target.value)}
/>
</div>

<div className="faq-list">

{filteredFAQ.map((faq, index) => (

<div
className={`faq-item ${activeIndex === index ? "active" : ""}`}
key={index}
>

<div
className="faq-question"
onClick={() => toggleFAQ(index)}
>

{t(faq.q)}

<span className="faq-icon">
{activeIndex === index ? "−" : "+"}
</span>

</div>

<div className="faq-answer">
{t(faq.a)}
</div>

</div>

))}

</div>

</div>

</section>
);
};

export default FAQ;